import { AudioPlayer } from './player';
import { SoundFileName } from './types';

import { browser } from '$app/environment';

const sounds = browser ? {
    messageNotification: new AudioPlayer(`/audio/${SoundFileName.MessageNotification}`),
    moneyPrize: new AudioPlayer(`/audio/${SoundFileName.MoneyPrize}`),
} : {};

export async function initSounds() {
    const soundsList = Object.values(sounds);

    try {
        for (const player of soundsList) {
            await player.init();
        }
    } catch (error) {
        console.error(error);
    }
}

async function play(sound: keyof typeof sounds) {
    try {
        if (sound in sounds) {
            await sounds[sound]?.play();
        }
    } catch (error) {
        console.error(error);
    }
}

export const audioService = {
    paidUserEntered: () => play('messageNotification'),
    giftReceived: () => play('moneyPrize'),
};
